<template>
  <div class="test">
    <h1 style="margin:auto;width:50%"> {{message}} </h1>
    <h2 v-if="demo" style="margin:auto;width:50%">{{demo_message}}</h2>
    <div style="margin:auto;width:50%">
      <v-stage v-show="started" ref="stage" :config="configKonva">
        <v-layer ref="layer">
          <v-rect ref="rect" :config="configRect" ></v-rect>
          <v-image ref="background" :config="configBackground" ></v-image>
          <v-image ref="object" :config="configObject"></v-image>

          <v-circle v-if="demo" ref="sign" :config="configSign"></v-circle>
          <v-line ref="markerline_left" :config="configMarkerLine_left"></v-line>
          <v-line ref="markerline_right" :config="configMarkerLine_right"></v-line>
        </v-layer>
        <v-layer ref="dragLayer">
            <v-image ref="figure" :config="configFigure" @dragmove="handleDrag" @dragend="handleDragEnd"></v-image>
        </v-layer>
      </v-stage>
      <b-button  :variant="isblocked ? 'danger' : 'secondary'" @click="next(false)" style="outline: none !important;   box-shadow: none; font-size: 24px; margin:5px">{{button_text}}</b-button>
      <b-button v-show="started" :variant="isblocked ? 'danger' : 'secondary'" @click="next(true)" style="outline: none !important;   box-shadow: none; font-size: 10px; margin:5px">{{didntheartext}}</b-button>

      <!-- <router-link :to="{ name: 'Results' }">
      <b-button  style="outline: none !important;   box-shadow: none;">skip to results (testing only)</b-button>
      </router-link> -->
    </div>
  </div>


</template>

<script>
import { mapState, mapMutations } from 'vuex'
const background = require('../assets/room_background.png')
const figure = require('../assets/figure.png')
const figure_right = require('../assets/figure_right.png')
const figure_left = require('../assets/figure_left.png')
const figure_walking_right = require('../assets/figure_walking_right.png')
const figure_walking_left = require('../assets/figure_walking_left.png')
const object_left = require('../assets/object_left.png')
const object_right = require('../assets/object_right.png')
const object_left_nosound = require('../assets/object_left_nosound.png')
const object_right_nosound = require('../assets/object_right_nosound.png')

export default {
  name: 'test',
  computed: {
    ...mapState(['lang','measurements','demos','_id'])
  },
  data () {
    return {
      configKonva: {
        width: 800,
        height: 453
      },
      past_pos: {
        x: 400
      },
      started: false,
      isblocked: false,
      figure_face_side: 0,
      block_counter: 0,
      demo_badpos_counter: 0,
      time_start: 0,
      time_sound_end: 0,
      time_click: 0,
      time_last_movement: 0,
      choose_side: 0,
      previous_side:-1,
      previous_sides_counter:0,
      button_text: 'start',
      demo: true,
      counter: 0,
      demolist: [],
      demolist_side: [0,1,0,1],
      demolist_markerplace: [730,580,300,250],
      demo_message: "",
      demo_text_list_en: [
        "Let's assume that this sound would scare you, and you would go farther away from the sound source under the cover. Please pull the figure to the red dot, which indicates a bigger distance from it.",
        "Let's assume that this sound would motivate you to go closer to the sound source under the cover. Please pull the figure to the red dot, which indicates a smaller distance from it.",
        "Let's assume that this sound would slightly motivate you to go closer to the sound source under the cover. Please pull the figure to the red dot, which indicates a smaller distance from it.",
        "Let's assume that this sound would slightly scare you, and you would go farther away from the sound source under the cover. Please pull the figure to the red dot, which indicates a bigger distance from it."
          ],
      demo_text_list_hu: [
        "Tegyük fel, hogy ettől a hangtól megijednél, azaz távolodnál a letakart hangforrástól. Kérjük húzd a figurát a piros pöttyre, mely egy távolabbi pontot jelöl.",
        "Tegyük fel, hogy ez a hang arra késztetne, hogy közelebb menj a letakart hangforráshoz. Kérjük húzd a figurát a piros pöttyre, mely egy közelebbi pontot jelöl.",
        "Tegyük fel, hogy ez a hang kicsit arra késztetne, hogy közelebb menj a letakart hangforráshoz. Kérjük húzd a figurát a piros pöttyre, mely egy közelebbi pontot jelöl.",
        "Tegyük fel, hogy ettől a hangtól kicsit megijednél, azaz távolodnál a letakart hangforrástól. Kérjük húzd a figurát a piros pöttyre, mely egy távolabbi pontot jelöl."

      ],
      testlist: [],
      message: '',
      stagewidth: 800,
      configBackground: {
        x: 0,
        y: 0,
        image: new Image(),
        width: 800,
        height: 453,
        draggable: true,
        dragBoundFunc: function(pos) {
          return {
              x: this.getAbsolutePosition().x,
              y: this.getAbsolutePosition().y
          }
        }
      },
      configSign:{
        x: -10,
        y: 370,
        radius: 10,
        fill: 'red'
      },
      configMarkerLine_left :{
        closed: false,
        strokeWidth:4,
        stroke:'red',
        points:[76*2,420,76*2,440,796,440,796,420],
        visible:false
      },
      configMarkerLine_right :{
        closed: false,
        strokeWidth:4,
        stroke:'red',
        points:[4,420,4,440,800-2*76,440,800-2*76,420],
        visible: false
      },
      configRect: {
        opacity:100 ,
        stroke: 'black',
        strokeWidth:4,
        width: 800,
        height: 453,
        x: 0,
        y: 0
      },
      configObject: {
        x: 0,
        y: 240,
        height: 124,
        width: 120,
        image: new Image(),
      },
      figurewidth : 106,
      objectwidth: 120,
      configFigure: {
        x: 400-132/2,
        y: 200,
        height: 160,
        width: 106,
        image: new Image(),
        draggable: true,
        dragBoundFunc: function(pos) {
          var this_x = pos.x
          if (this_x < 120){
            this_x = 120
          }
          else if (this_x > 800-106){
            this_x = 800-106
          }
          return {
              x: this_x,
              y: this.getAbsolutePosition().y
          }
        }
      },
      figureDragBoundFund_left: function(pos) {
        var this_x = pos.x
        var margin_stage = 9
        var margin_obj = 9
        if (this_x < 120 - margin_obj){
          this_x = 120 - margin_obj
        }
        else if (this_x > 800-106+margin_stage){
          this_x = 800-106+margin_stage
        }
        return {
            x: this_x,
            y: this.getAbsolutePosition().y
        }
      },
      figureDragBoundFund_right: function(pos) {
        var this_x = pos.x
        var margin_stage = 9
        var margin_obj = 9
        if (this_x < 0 -margin_stage){
          this_x = 0 -margin_stage
        }
        else if (this_x > 800-106-120 + margin_obj){
          this_x = 800-106 -120 + margin_obj
        }
        return {
            x: this_x,
            y: this.getAbsolutePosition().y
        }
      }
    }
  },
  methods: {
    ...mapMutations(['addMeasurement','addDemo']),
    handleDragEnd(vueComponent,event){
      this.time_last_movement = window.performance.now()
      if (this.figure_face_side == 1) {
        this.configFigure.image.src = figure_right
      }
      else if (this.figure_face_side == 0) {
        this.configFigure.image.src = figure_left
      }

    },
    handleDrag (vueComponent,event){
        if (this.$refs.figure.getStage().attrs.x < this.past_pos.x) {
          this.configFigure.image.src = figure_walking_right
          this.figure_face_side = 1
        }
        else if (this.$refs.figure.getStage().attrs.x > this.past_pos.x) {
          this.configFigure.image.src = figure_walking_left
          this.figure_face_side = 0
        }
        this.past_pos.x = this.$refs.figure.getStage().attrs.x

    },
    tick (){
      window.setInterval(()=>{
        this.$refs.stage.getStage().draw()
      },100)
    },
    next (didnthear){

      this.started = true
      console.log("this counter " + this.counter)
      if (this.isblocked){
        this.block_counter++
        console.log("blocked: " + this.block_counter)
      }
      else{



        if (this.demo) {
          this.button_text = this.lang == 'en' ? 'next' : 'következő'

          if (this.counter > 0 && this.counter < 5){
            if (Math.abs(this.$refs.figure.getStage().attrs.x + this.figurewidth/2 - this.$refs.sign.getStage().attrs.x) < 20 || didnthear){
                console.log("ok :" + Math.abs(this.$refs.figure.getStage().attrs.x + this.figurewidth/2- this.$refs.sign.getStage().attrs.x))
                this.time_click = window.performance.now()
                this.choose_side = this.demolist_side[this.counter -1]

                var figx = this.$refs.figure.getStage().attrs.x + this.figurewidth/2
                var objectx = this.$refs.object.getStage().attrs.x + this.objectwidth/2
                var res = {
                  'time_to_sound_end': this.time_sound_end - this.time_start,
                  'time_to_last_movement': this.time_last_movement - this.time_start,
                  'time_to_click': this.time_click - this.time_start,
                  'distance': Math.abs(figx-objectx),
                  'block_counter': this.block_counter,
                  'side': this.choose_side,
                  'figure_face_side': this.figure_face_side,
                  'sound': this.demolist[this.counter - 1],
                  'time_start': this.time_start,
                  'time_sound_end': this.time_sound_end,
                  'time_last_movement': this.time_last_movement,
                  'time_click': this.time_click,
                  'demo': true,
                  'demo_badpos_counter': this.demo_badpos_counter,
                }
                if (didnthear){
                  res['sound'] = "nosound_" + res['sound']
                }
                console.log(res)
                this.addDemo(res)


                this.$http.post('/api/addMeasurement',{'_id':this._id,'measurement':res}).then(
                  res => {
                    if (res.body.status == 'ok'){
                      console.log("add measurement ok")
                      console.log(res.body)
                    }
                    else{
                      console.log("add measurement not ok")
                    }
                  },
                  res => {console.log('err')}
                )
                console.log(this.demos)
                this.demo_badpos_counter = 0
            }
            else{
              this.demo_badpos_counter++
              console.log("returning :" + Math.abs(this.$refs.figure.getStage().attrs.x + this.objectwidth/2 - this.$refs.sign.getStage().attrs.x))
              return
            }
          }
          if (this.counter == 4 ){
            console.log("here")
            this.configFigure.image.src = figure
            this.$refs.sign.getStage().to({x:1000,duration:0})
            this.$refs.figure.getStage().to({x:400 -86/2,duration:0})
            this.demo = false
            this.blocked = false
            this.block_counter = 0
            this.counter = 0
            this.started = false
            this.button_text = this.lang == 'en' ? 'start' : 'start'
            this.didntheartext = this.lang == 'en' ? 'Did not hear a sound' : 'Nem hallottam hangot'
            this.message = (this.lang == 'en' ? "The test will start after pressing the start button. You won't see a red dot anymore, it's up to you to decide how close or far would you go from the sound source. Please pull the figure there. " : 'A teszt a start gomb megnyomása után indul. A továbbiakban nem látsz majd piros pöttyöt, hanem neked kell eldöntened, mennyire mennél közel vagy távolodnál el a hangforrástól. Kérjük, húzd oda a figurát.  ')
            return
          }
          this.measurement = {}
          this.block_counter = 0
          this.isblocked = true
          this.configFigure.image.src = figure
          this.counter++
          this.message =  (this.lang == 'en' ? "Demo: " : "Demo: ") + " " + (this.counter) +"/4"
          this.demo_message = this.lang == 'en' ? this.demo_text_list_en[this.counter - 1 ] : this.demo_text_list_hu[this.counter - 1 ]
          this.button_text = this.lang == 'en' ? 'next' : 'következő'
          this.didntheartext = this.lang == 'en' ? 'Did not hear a sound' : 'Nem hallottam hangot'
          this.$refs.sign.getStage().to({x:this.demolist_markerplace[this.counter -1],duration:0})
          this.choose_side = this.demolist_side[this.counter -1]
          console.log("where",this.choose_side)
          var c_ = this.stagewidth-this.figurewidth-this.objectwidth
          this.choose_side == 0 ? this.$refs.figure.getStage().to({x:c_/2+this.objectwidth,duration:0}) : this.$refs.figure.getStage().to({x:c_/2,duration:0})
          if (this.choose_side){
              // this.$refs.markerline_right.getStage().show()
              // this.$refs.markerline_left.getStage().hide()
              this.$refs.figure.getStage().dragBoundFunc(this.figureDragBoundFund_right)
          }
          else{
            // this.$refs.markerline_right.getStage().hide()
            // this.$refs.markerline_left.getStage().show()
            this.$refs.figure.getStage().dragBoundFunc(this.figureDragBoundFund_left)
          }
          // var thisobject = new Image()
          // thisobject.src = object_right
          // thisobject.onchange = () => {
          //   this.$refs.object.getStage().setImage(thisobject)
          //   this.$refs.layer.getStage().draw()
          // }
          this.time_start = window.performance.now()
          this.time_to_last_movement = this.time_start
          var audio = new Audio(this.demolist[this.counter - 1])
          this.configObject.image.src = this.demolist_side[this.counter - 1] == 0 ? object_right : object_left
          var objectplace = this.demolist_side[this.counter - 1] == 0 ? 0 : this.stagewidth-this.objectwidth

          this.$refs.object.getStage().to({x:objectplace,duration:0})
          audio.onended = () => {
            this.time_sound_end = window.performance.now()
            this.isblocked = false
            this.configObject.image.src = this.demolist_side[this.counter - 1] == 0 ? object_right_nosound : object_left_nosound

            this.$refs.object.getStage().to({x:objectplace,duration:0})

          }
          audio.play()



        }
        else {
            if (this.counter > 0){
              this.time_click = window.performance.now()
              var figx = this.$refs.figure.getStage().attrs.x + this.figurewidth/2
              var objectx = this.$refs.object.getStage().attrs.x + this.objectwidth/2
              var res = {
                'time_to_sound_end': this.time_sound_end - this.time_start,
                'time_to_last_movement': this.time_last_movement - this.time_start,
                'time_to_click': this.time_click - this.time_start,
                'distance': Math.abs(figx-objectx),
                'block_counter': this.block_counter,
                'side': this.choose_side,
                'figure_face_side': this.figure_face_side,
                'sound': this.testlist[this.counter - 1],
                'time_start': this.time_start,
                'time_sound_end': this.time_sound_end,
                'time_last_movement': this.time_last_movement,
                'time_click': this.time_click,
                'demo': false,
              }
              if (didnthear){
                res["sound"] = "nosound_" + res['sound']
              }
              console.log(res)
              this.addMeasurement(res)
              this.$http.post('/api/addMeasurement',{'_id':this._id,'measurement':res}).then(
                res => {
                  if (res.body.status == 'ok'){
                    console.log(res.body)
                  }
                },
                res => {console.log('err')}
              )
              console.log(this.measurements)
            }
            if (this.counter == this.testlist.length){
              this.$http.post('/api/markFinished',{'_id':this._id}).then(
                res => {
                  if (res.body.status == 'ok'){
                    console.log(res.body)
                  }
                },
                res => {console.log('err')}
              )
              this.$router.push("/thankyou")
            }
            this.block_counter = 0
            this.button_text = this.lang == 'en' ? 'next' : 'következő'
            this.didntheartext = this.lang == 'en' ? 'Did not hear a sound' : 'Nem hallottam hangot'
            this.isblocked = true
            this.configFigure.image.src = figure
            this.message = (this.lang == 'en' ? 'Test: how far or close would you go?     ' : 'Teszt: mennyire mennél távol vagy közel?     ') + (this.counter + 1) +"/" + this.testlist.length
            this.choose_side = Math.random() < 0.5 ? 0 : 1
            console.log("before",this.choose_side,this.previous_side,this.previous_sides_counter)
            if (this.choose_side == this.previous_side){
              this.previous_sides_counter++
            }
            else{
              this.previous_sides_counter = 0
            }
            if (this.previous_sides_counter == 2){
              this.choose_side = this.choose_side == 0 ? 1 : 0
              this.previous_sides_counter = 0
            }
            this.previous_side = this.choose_side
            console.log("after",this.choose_side,this.previous_side,this.previous_sides_counter)
            if (this.choose_side){
                // this.$refs.markerline_right.getStage().show()
                // this.$refs.markerline_left.getStage().hide()
                this.$refs.figure.getStage().dragBoundFunc(this.figureDragBoundFund_right)
            }
            else{
              // this.$refs.markerline_right.getStage().hide()
              // this.$refs.markerline_left.getStage().show()
                this.$refs.figure.getStage().dragBoundFunc(this.figureDragBoundFund_left)
            }
            this.time_start = window.performance.now()
            this.time_to_last_movement = this.time_start
            var audio = new Audio(this.testlist[this.counter])
            var c_ = this.stagewidth-this.figurewidth-this.objectwidth
            this.choose_side == 0 ? this.$refs.figure.getStage().to({x:c_/2+this.objectwidth,duration:0}) : this.$refs.figure.getStage().to({x:c_/2,duration:0})
            this.configObject.image.src = this.choose_side == 0 ? object_right : object_left
            var objectplace = this.choose_side == 0 ? 0 : this.stagewidth-this.objectwidth
            this.$refs.object.getStage().to({x:objectplace,duration:0})
            audio.onended = () => {
              this.time_sound_end = window.performance.now()
              this.isblocked = false
              this.configObject.image.src = this.choose_side == 0 ? object_right_nosound : object_left_nosound
              this.$refs.object.getStage().to({x:objectplace,duration:0})
              this.counter++

            }
            audio.play()
          }
        }
    },

  },

  mounted () {
    // this.configBackground.image.src ='http://soundrating3.elte.hu/api/get_background'
    // this.configCircle.fillPatternImage.src ='http://soundrating3.elte.hu/api/get_background'
    this.tick()
    console.log("ticking")
    this.configBackground.image.src = background
    this.configObject.image.src = object_right_nosound
    this.configFigure.image.src = figure
    this.figurewidth = 106
    this.objectwidth = 120
    this.stagewidth = 800
    this.$refs.figure.getStage().width(this.figurewidth)
    this.$refs.object.getStage().width(this.objectwidth)
    this.$refs.background.getStage().width(this.stagewidth)
    this.$refs.stage.getStage().width(this.stagewidth)
    this.$refs.rect.getStage().width(this.stagewidth)

    console.log("side",this.choose_side)
    this.message = this.lang == 'en' ? "Demo: First you will hear four demo sounds. Please follow the instructions.  During the demo and the test you will see multiple buttons on the screen, which will only start working after the full sound has been played. This is signalled by the buttons turning grey from red." : "Demó: Először négy demó hangot fogsz hallani, kérjük kövesd az utasításokat. A demó és a teszt során a képernyőn több gomb is látható lesz, melyek csak az egyes hangok lejátszása után fognak működni. Ezt jelzi, hogy a gombok színe pirosról szürkére változik."

    // this calls an update inside konva I guess, so is a workaround

    this.$refs.stage.getStage().draw()

    this.$http.get('/api/demosounds').then(response => {
       this.demolist = response.body;
       console.log("demolist: ", this.demolist)
     }, response => {
       // error callback
     });

    this.$http.get('/api/testsounds').then(response => {
        this.testlist = response.body;
        console.log("testlist: ", this.testlist)
      }, response => {
        // error callback
      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tbn:focus,.btn:active {
  outline: none !important;
  box-shadow: none;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Test.vue